export const recordingFeesHeadingLabels = [
  { label: 'Recording Type', align: 'left' },
  { label: 'Fee', align: 'left' },
  { label: 'Amount', align: 'right' },
];
